const elementStyles = (element) => element.ownerDocument.defaultView.getComputedStyle(element);
const cache = {};
const toColor = (colorMix, element) => {
    if (cache[colorMix]) {
        return cache[colorMix];
    }
    const curColor = element.style.color;
    element.style.color = colorMix;
    const color = elementStyles(element).color;
    element.style.color = curColor;
    cache[colorMix] = color;
    return color;
};
const getProp = (element, prop) => {
    let value = elementStyles(element).getPropertyValue(prop);
    if (/^color-mix/i.test(value)) {
        value = toColor(value, element);
    }
    return value;
};
export const loadTheme = (element) => {
    const primaryBg = getProp(element, '--kendo-chart-primary-bg');
    const primaryContrast = getProp(element, '--kendo-chart-primary-contrast');
    const normalTextColor = getProp(element, '--kendo-chart-text');
    const normalBackground = getProp(element, '--kendo-color-surface');
    const selectionColor = '#0B99FF';
    return {
        shapeDefaults: {
            fill: {
                color: primaryBg
            },
            content: {
                color: primaryContrast
            },
            connectorDefaults: {
                fill: {
                    color: selectionColor
                },
                stroke: {
                    color: primaryContrast
                },
                hover: {
                    fill: {
                        color: selectionColor
                    },
                    stroke: {
                        color: selectionColor
                    }
                }
            }
        },
        editable: {
            resize: {
                handles: {
                    width: 10,
                    height: 10,
                    stroke: {
                        color: selectionColor
                    },
                    fill: {
                        color: normalBackground
                    },
                    hover: {
                        stroke: {
                            color: selectionColor
                        },
                        fill: {
                            color: selectionColor
                        }
                    }
                }
            }
        },
        selectable: {
            stroke: {
                color: selectionColor
            }
        },
        connectionDefaults: {
            stroke: {
                color: normalTextColor
            },
            content: {
                color: normalTextColor,
                bgColor: primaryContrast
            },
            selection: {
                handles: {
                    fill: {
                        color: primaryContrast
                    },
                    stroke: {
                        color: normalTextColor
                    },
                    width: 8,
                    height: 8
                },
                stroke: {
                    color: normalTextColor
                }
            },
            editable: {
                points: {
                    midpoint: {
                        fill: {
                            color: selectionColor
                        },
                        stroke: {
                            color: primaryContrast,
                            width: 1
                        },
                        radius: 4,
                    },
                    vertex: {
                        fill: {
                            color: primaryContrast
                        },
                        stroke: {
                            color: selectionColor,
                            width: 2
                        },
                        radius: 3
                    }
                }
            }
        }
    };
};
